import { render, staticRenderFns } from "./ImportUsers.vue?vue&type=template&id=08bf2820&"
import script from "./ImportUsers.vue?vue&type=script&lang=js&"
export * from "./ImportUsers.vue?vue&type=script&lang=js&"
import style0 from "./ImportUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports